<template>
  <fader animation="delayfade" v-if="round">
    <div
      class="flex justify-center items-center h-36 lg:h-40"
      data-test="roundCounter"
    >
      <button
        title="Previous turn"
        class="u-button-unstyle py-4 px-8 -mx-6 -my-3 text-7xl opacity-40 hover:opacity-100 pointer-events-auto"
        data-test="decrement-turn"
        @click="$emit('decrement')"
      >
        <angle-bracket
          class="text-accent hover:text-accent block"
          direction="left"
          >Previous turn</angle-bracket
        >
      </button>

      <h1 class="relative text-center">
        <small
          style="transform: translateX(-50%)"
          class="tracking-wide text-xs uppercase absolute b-full l-half whitespace-no-wrap mb-2"
          >Round
          <strong data-test="round" class="bold text-white">{{
            round
          }}</strong></small
        >
        <big :class="$options.$style.turn" data-test="currentCombatant">{{
          turnName
        }}</big>
      </h1>

      <button
        title="Start next round"
        class="u-button-unstyle py-4 px-8 -mx-6 -my-3 text-7xl opacity-40 hover:opacity-100 pointer-events-auto"
        data-test="increment-turn"
        @click="$emit('increment')"
      >
        <angle-bracket class="text-accent block">Next turn</angle-bracket>
      </button>
    </div>
  </fader>
</template>

<script>
import AngleBracket from './AngleBracket'

const $style = {
  turn: `
    text-2xl md:text-3xl lg:text-4xl font-serif text-white
  `,
}

const formElements = `input textarea datalist`.toUpperCase().split(` `)

export default {
  components: {
    AngleBracket,
  },
  props: {
    round: {
      type: Number,
      default: 1,
    },
    currentCombatantName: {
      type: String,
    },
  },
  created() {
    this.subArrowKeyHandler()
  },
  beforeDestroy() {
    this.unSubArrowKeyHandler()
  },
  computed: {
    turnName() {
      return this.currentCombatantName.trim() === ``
        ? `unnamed combatant`
        : this.currentCombatantName
    },
  },
  methods: {
    arrowKeyHandler(e) {
      if (formElements.includes(document.activeElement.tagName)) return
      if (e.keyCode === 37) this.$emit(`decrement`)
      if (e.keyCode === 39) this.$emit(`increment`)
    },
    subArrowKeyHandler() {
      document.addEventListener(`keyup`, this.arrowKeyHandler)
    },
    unSubArrowKeyHandler() {
      document.removeEventListener(`keyup`, this.arrowKeyHandler)
    },
  },
  $style,
}
</script>
